export const filterSubmenus = (menus, id) => {
    const filter_only_submenus = menus.filter(item => item?.ID_Menu_Pai === id)
    return filter_only_submenus
}